export default "__VITE_PUBLIC_ASSET__601913a5__"